import { Component } from '@angular/core';

import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-access-denied',
  imports: [HeaderComponent],
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss',
})
export class AccessDeniedComponent {}
